import { storeToRefs } from 'pinia';

import { useCitiesStore } from '@/store/cities';
import { useProjectsStore } from '@/store/projects';

export const useProjectOptions = () => {
  const citiesStore = useCitiesStore();
  const { cities } = storeToRefs(citiesStore);

  const projectsStore = useProjectsStore();
  const { projectsOptions, globalProjects } = storeToRefs(projectsStore);

  /**
   * Фильтруем проекты по выбранному городу
   * @return Список отфильтрованных проектов {@link projectsOptions}
   */
  function filteredProjectsOptions (activeCity?: number | null, forcedProject?: number) {
    if (!activeCity) {
      return projectsOptions.value;
    }

    const currentCity = cities.value?.find(({ value }) => value === activeCity);

    /**
     * Сделано для проектов коммерции, которые отфильтровываются на фиксации.
     * Подставляем выбранный проект в задизейбленное поле формы
     */
    const hasForcedProject = projectsOptions.value.find(({ value }) => forcedProject === value);

    if (!hasForcedProject && forcedProject) {
      return globalProjects.value.filter(({ id }) => id === forcedProject).map(({
        name,
        id,
        city,
      }) => ({
        id,
        text: name,
        value: id,
        citySlug: city.slug,
      }));
    }

    return projectsOptions.value.filter(({ citySlug }) => citySlug === currentCity?.citySlug);
  }

  return {
    filteredProjectsOptions,
  };
};
